import { Database, Q } from '@nozbe/watermelondb'

export const deleteChats = async (database: Database, openChatKey?: string) => {
  await database.write(async () => {
    await database
      .get('chats')
      .query(Q.where('key', Q.notEq(openChatKey ?? '')))
      .markAllAsDeleted()
  })
}
